<template>
  <i :class="computedClass" :data-cy="dataCy" :name="name" @click="onClick" />
</template>

<script>
export default {
  name: 'Icon',
  computed: {
    computedClass() {
      return `icon-${this.name}`;
    },
  },
  methods: {
    onClick($event) {
      this.$emit('click', $event);
  },
  },
  props: {
    className: {
      type: String,
      required: false,
    },
    dataCy: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
  },
};
</script>
